export const prepareStructure = (fileList: any[]) => {
  return fileList.reduce((stucture: any[], elem: any) => {
    const file = elem.name;
    const path = elem.webkitRelativePath || elem.path;
    const name = path?.split('/')[0];

    const itemForRender = path 
      ? path?.split('/').length === 1
        ? { uid: elem.uid, name: path.split('/')[0], type: 'file', path, file, children: [] }
        : { uid: elem.uid, name: path.split('/')[0], type: 'folder', path, file, children: [] }
      : { uid: elem.uid, name: elem.name, type: 'file', path, file, children: [] };

    const indexOfTargetElem = stucture.findIndex(item => item.name === itemForRender.name)    
    if (indexOfTargetElem === -1) {
      return [
        ...stucture,
        {
          ...itemForRender,
          children: [{...itemForRender, path: path?.replace(`${name}/`, '')}]
        }
      ];
    } else {
      stucture[indexOfTargetElem]?.children.push({...itemForRender, path: path?.replace(`${name}/`, '')});
    }
    return stucture;
  }, [])
}
